import { request } from 'umi';
import { APIConfig } from '@/config/common';
export async function getCaptcha(params: any) {

	return request(`${APIConfig.APIPrefix}/sys/user/getCaptcha`, {
		method: 'POST',
		data: params,
	});
}
export async function userLogin(params: any) {

	return request(`${APIConfig.APIPrefix}/sys/user/login`, {
		method: 'POST',
		data: params,
	});
}
export async function ssoLogin(params: any) {

	return request(`${APIConfig.APIPrefix}/sys/user/ssologin`, {
		method: 'POST',
		data: params,
	});
}
export async function wxLogin(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/login/wx`, {
		method: 'POST',
		data: params,
	});
}
export async function getCurrentUser(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/currentuser`, {
		method: 'POST',
		data: params,
	});
}
export async function getUserMenu(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/authority/menu`, {
		method: 'POST',
		data: params,
	});
}
export async function GetDataList(params?: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/list`, {
		method: 'POST',
		data: {
			...params
		},

	});
}

export async function SaveData(params: any) {
	if (params?.id) {
		return request(`${APIConfig.APIPrefix}/sys/user/update`, {
			method: 'POST',
			data: {
				...params
			},

		});

	}
	return request(`${APIConfig.APIPrefix}/sys/user/add`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function SaveGrantData(params: any) {
	if (params?.id) {
		return request(`${APIConfig.APIPrefix}/sys/user/grant/add`, {
			method: 'POST',
			data: {
				...params
			},

		});

	}
}
export async function SaveRoleData(params: any) {
	if (params?.id) {
		return request(`${APIConfig.APIPrefix}/sys/user/role/add`, {
			method: 'POST',
			data: {
				...params
			},

		});

	}
}
export async function SaveDeviceData(params: any) {

	return request(`${APIConfig.APIPrefix}/sys/user/device/add`, {
		method: 'POST',
		data: {
			...params
		},

	});


}
export async function DeleteDeviceData(params: any) {

	return request(`${APIConfig.APIPrefix}/sys/user/device/delete`, {
		method: 'POST',
		data: {
			...params
		},

	});


}
export async function DeleteData(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/delete`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function unBind(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/unbind`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function resetPassword(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/resetpassword`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function updatePassword(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/updatepassword`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function updatePassword2(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/updatepassword2`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}
export async function getUpdatePassWordSmsCode(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/getUpdatePassWordSmsCode`, {
		method: 'POST',
		data: {
			...params,
		},
	});
}

export async function jumpsystem(params: any) {
	return request(`${APIConfig.APIPrefix}/sys/user/jumpsystem`, {
		method: 'POST',
		data: params,
	});
}